import { useEffect, useState } from "react";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { InfoSection } from "@/components/site/InfoSection";
import { RegistrationForm } from "@/components/site/RegistrationForm";
import { SuccessSlip } from "@/components/site/SuccessSlip";
import { Footer } from "@/components/site/Footer";
import { Motivation } from "@/components/site/Motivation";
import DataPage from "@/components/site/DataPage";
import SlipPage from "@/components/site/SlipPage";
import { WhatsAppFab, WhatsAppHelpCard } from "@/components/site/WhatsAppHelp";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const slipMatch = window.location.pathname.match(/^\/slip\/([A-Za-z0-9-]+)/);
  if (slipMatch) {
    return (
      <div className="App gp-root">
        <SlipPage regId={slipMatch[1]} />
      </div>
    );
  }
  if (window.location.pathname.startsWith("/registrations")) {
    return (
      <div className="App gp-root">
        <Toaster position="top-center" richColors />
        <Header />
        <DataPage />
      </div>
    );
  }
  return <Home />;
}

function Home() {
  const [result, setResult] = useState(null);
  const [formInView, setFormInView] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 650);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    const el = document.getElementById("register");
    if (!el) return;
    const io = new IntersectionObserver(([e]) => setFormInView(e.isIntersecting), { threshold: 0.05 });
    io.observe(el);
    return () => io.disconnect();
  }, [result]);
  return (
    <div className="App gp-root">
      <Toaster position="top-center" richColors />
      <div className="no-print">
        <Header />
        <Hero />
        <InfoSection />
        <Motivation />
        {result ? (
          <SuccessSlip data={result} onNew={() => setResult(null)} />
        ) : (
          <RegistrationForm onSuccess={setResult} />
        )}
        <div className="gp-container pb-24 sm:pb-14">
          <WhatsAppHelpCard />
        </div>
        <Footer />
        {!result && scrolled && !formInView && (
          <a href="#register" className="mobile-cta" data-testid="mobile-quick-register-btn">
            अभी पंजीकरण करें · Register Now
          </a>
        )}
        <WhatsAppFab />
      </div>
      {result && <SuccessSlip data={result} printOnly />}
    </div>
  );
}

export default App;
